(function (Drupal) {
  Drupal.behaviors.ourPlans = {
    attach: function (context, settings) {
      const paragraphTypeOurPlans = context.querySelectorAll(".paragraph--type--our-plans .field--name-field-plan");

      if (paragraphTypeOurPlans.length > 0) {
        const planTabsContainer = context.querySelector(".paragraph--type--block-embed");

        const ul = document.createElement('ul');
        ul.className = 'nav nav-tabs';
        ul.id = 'planTabs';
        ul.role = 'tablist';

        const tabContent = document.createElement('div');
        tabContent.className = 'tab-content';
        tabContent.id = 'planTabContent';

        paragraphTypeOurPlans.forEach((plan, index) => {
          const tabId = `tab${index + 1}`;
          const planId = `plan${index + 1}`;

          const accordion = plan.nextElementSibling;
          if (accordion && accordion.classList.contains('field--name-field-accordion')) {
            const accordionItems = accordion.querySelectorAll('.field--name-field-poblacion');

            const accordionList = document.createElement('ul');
            accordionList.className = 'accordion-list';
            accordionItems.forEach((item, itemIndex) => {
              const listItem = document.createElement('li');
              const listItemSpan = document.createElement('span');

              listItem.classList.add("poblacion");
              listItemSpan.textContent = item.textContent.replace(/_/g, " ").replace(/\banos\b/g, "años").trim();           
              listItem.addEventListener('click', () => {
                console.log("click");
                
                accordionList.querySelectorAll('li.poblacion').forEach(li => {
                  li.classList.remove('active');
                });
                accordionItems.forEach((accItem, accIndex) => {
                  if (itemIndex === accIndex) {
                    listItem.classList.add("active");
                    accItem.closest('.card-additional-information').classList.add('show');
                  } else {
                    accItem.closest('.card-additional-information').classList.remove('show');
                  }
                });
              });
              if(itemIndex === 0) {
                listItem.click();
              }
              listItem.appendChild(listItemSpan);
              accordionList.appendChild(listItem);
            });

            const li = document.createElement('li');
            li.className = 'nav-item';
            li.innerHTML = `
              <a class="nav-link ${index === 0 ? 'active' : ''}" id="${tabId}-tab" data-bs-toggle="tab" href="#${planId}" role="tab" aria-controls="${planId}" aria-selected="${index === 0}">
                ${plan.textContent.replace("_", " ")}
              </a>
            `;
            ul.appendChild(li);

            const planWrapper = document.createElement('div');
            planWrapper.classList.add('tab-pane', 'fade');
            planWrapper.id = planId;
            if (index === 0) {
              planWrapper.classList.add('show', 'active');
              
            }
            console.log("ola");
            
            planWrapper.appendChild(plan);
            planWrapper.appendChild(accordionList);
            planWrapper.appendChild(accordion);

            tabContent.appendChild(planWrapper);
          }
        });

        planTabsContainer.classList.add('card-plan')
        planTabsContainer.appendChild(ul);
        planTabsContainer.appendChild(tabContent);
      }
    }
  }
})(Drupal);
